const SET_ACCESS = "SET_ACCESS";
const CLEAR_ACCESS = "CLEAR_ACCESS";

export const setAccess = (payload) => ({
  type: SET_ACCESS,
  payload,
});

export const clearAccess = () => ({
  type: CLEAR_ACCESS,
});

const initialState = {
  data: null
};

export default function accessReducer(state = initialState, action) {
  switch (action.type) {
    case SET_ACCESS:
      return {
        ...state,
        data: action.payload
      };
    case CLEAR_ACCESS:
      return initialState;
    default:
      return state;
  }
}